import { fg } from '@atlaskit/platform-feature-flags';

const STORE_MESSAGE_KEY = 'search-ai.sain.store_message';

function shouldStoreMessage(): boolean {
	if (!fg('kd_sain_enable_arize_hello_only')) {
		return false;
	}
	try {
		// TODO(MIGRATE-STORAGE-BASELINE): migrate to @atlassian/search-common/local-storage wrapper
		// eslint-disable-next-line @atlassian/search-common/no-direct-local-storage
		const stored = localStorage.getItem(STORE_MESSAGE_KEY);
		return stored === null || stored === 'true';
	} catch {
		return true;
	}
}

export const getStoreMessageHeader = (): { store_message?: string } => {
	return shouldStoreMessage() ? { store_message: 'true' } : {};
};

export const getStoreMessageBodyParam = (): { store_message?: boolean } => {
	return shouldStoreMessage() ? { store_message: true } : {};
};
